/**
 * Whether a Mux playback error should trigger one automatic remount/reload.
 *
 * @param attempt - Zero-based retry count already performed
 * @returns True only for the first failure
 */
export const shouldRetryMuxPlayback = (attempt: number): boolean => {
	return attempt < 1;
};
